import {
 useCallback, useState, useMemo, useEffect,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';

import alarmsApi from '@api/alarmsApi';
import alarmsActions from '@state/alarms/actions';
import * as alertsNames from '@pages/Alertas/helpers/defaultAlerts/alertsNames';

function useAlarmRuleItem({ id, name }) {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  // const [loadingDelete, setLoadingDelete] = useState(false);
  const idsInDeleting = useSelector(({ alarms: a }) => a.idsInDeleting);
  const [isAdmin, setIsAdmin] = useState(false);
  const currentUser = useSelector(({ user }) => user);

  const [loadingActive, setLoadingActive] = useState(false);

  const onEditAlarm = useCallback(() => {

    history.push(`/reglas/dinamicas/${id}`);
    // eslint-disable-next-line
  }, [id]);

  const onDeleteAlarm = useCallback(() => {

    // setLoadingDelete(true);
    dispatch(alarmsActions.startDeletingAlarm(id));
    alarmsApi
      .deleteAlarmById({ id })
      .then(() => {

        // setLoadingDelete(false);
        dispatch(alarmsActions.deleteAlarm(id));
        message.success(t('views.dynamic_alarms.feedbacks.delete_alarms.success_delete'));

      })
      .catch((resError) => {

        // setLoadingDelete(false);
        const { fem } = resError;
        // eslint-disable-next-line
        console.log(t(fem));

      });
    // eslint-disable-next-line
  }, [id]);

  const onSetActive = useCallback(
    (checked) => {

      const body = { is_active: checked };

      setLoadingActive(true);
      alarmsApi
        .partialUpdateAlarm({ id, body })
        .then((response) => {

          const array = [];
          response.conditions.forEach((condition) => {

            const rules = [];
            condition.forEach((data) => {

              const value = {
                type: data.type,
                params: {
                  field: data.field,
                  value: data.value,
                  operator: data.operator,
                },
              };
              rules.push(value);

            });
            array.push(rules);

          });
          const action_array = [];
          response.actions.forEach((data) => {

            const action = {
              type: data.type,
              params: {
                recipients: [data.recipients],
              },
            };
            action_array.push(action);

          });
          response.conditions = array;
          response.actions = action_array;

          dispatch(alarmsActions.editAlarm(response));
          setLoadingActive(false);

        })
        .catch((resError) => {

          const { fem } = resError;
          // eslint-disable-next-line
          console.log(t(fem));
          setLoadingActive(false);

        });

    },
    // eslint-disable-next-line
    [id]
  );

  const loadingDelete = useMemo(() => idsInDeleting.includes(id), [id]);

  const isDefaulAlarm = useMemo(() => {

    if (!name) return false;
    return Object.values(alertsNames).includes(name);

  }, [name]);

  const getPermissonCreate = useCallback(() => {

    const currentUserRole = currentUser.role;
      // eslint-disable-next-line
      setIsAdmin(!!(currentUserRole === 'Superadmin' || currentUserRole === 'Admin'));

  }, []);

  useEffect(() => {

    getPermissonCreate();

}, []);

  return {
    onEditAlarm,
    onDeleteAlarm,
    onSetActive,
    loadingDelete,
    loadingActive,
    isAdmin,
    isDefaulAlarm,
  };

}

export default useAlarmRuleItem;
